import { InfoTable } from '../../../js/portal/main';
import { DetailsTabLayout, TabPane, DetailSection } from './DetailsTabLayout';

export default function ClusterTabs(props) {
  const { data } = props;

  const cluster_id = data?.project_name?.replaceAll(' ', '_');
  const tabId = 'project_' + cluster_id;

  return (
    <DetailsTabLayout tabs={[{ id: tabId, label: 'Project' }]}>
      <TabPane id={tabId} active name="project-container">
        <div class="col-lg-12 col-xl-12">
          <DetailSection title="4wheels Project Details">
            <InfoTable
              data={data}
              rowInfos={[
                { Name: 'Account Id', Value: 'account_id' },
                { Name: 'Account DL', Value: 'account_dl' },
                { Name: 'Project Name', Value: 'project_name' },
                { Name: 'Cluster Name', Value: 'details.cluster_name' },
                { Name: 'Cluster Size', Value: 'cluster_size' },
                { Name: 'Kubernetes Version', Value: 'details.k8s_version' },
                { Name: 'CPU Architecture', Value: 'cpu_architecture' },
                { Name: '4Wheels Guided Version', Value: '4wg_version' },
                { Name: 'VPC ID', Value: 'vpc_id' },
                { Name: 'Route 53 Zone Name', Value: 'zone_name' },
                { Name: 'Region', Value: 'region' },
                { Name: 'Logging Stack', Value: 'logging_stack' },
                { Name: 'Alert Manager', Value: 'details.alertmanager' },
                { Name: 'Grafana', Value: 'details.grafana' },
                { Name: 'Kibana', Value: 'details.kibana' },
                { Name: 'Prometheus', Value: 'details.prometheus' },
                { Name: 'ArgoCD', Value: 'details.argocd' },
                { Name: 'ArgoCD Access Command', Value: 'details.argocd_access' },
                { Name: 'Resource Group', Value: 'details.resource_group' },
                { Name: 'Cluster Access Command', Value: 'details.cluster_access_com' },
                { Name: 'Order Id', Value: 'order_id' },
                { Name: 'Order Proposer', Value: 'order_proposer' },
                { Name: 'Creation Date', Value: 'details.creation_date' },
                { Name: 'Project Status', Value: 'status' },
                { Name: 'Status Details', Value: 'status_message' },
                { Name: 'Last Status Update (UTC)', Value: 'status_update' },
              ]}
            />
          </DetailSection>
        </div>
      </TabPane>
    </DetailsTabLayout>
  );
}
